import React from "react";

const StaticInfo = () => {
  return (
    <div className="mx-auto max-w-screen-lg px-4 lg:px-2 flex flex-col items-center">
      <div className="absolute bottom-0 left-0 hidden lg:block">
        <img
          src="https://www.zephyrus.co.uk/solar-planetary-system-animation-new2.gif"
          alt="Solar Planetary System Animation"
          className="w-96"
        />
      </div>
      <div className="absolute top-0 right-0 hidden lg:block">
        <img
          src="https://i.pinimg.com/originals/8e/1c/cc/8e1cccc79861e9619eb98bfdc870c73b.gif"
          alt="Solar Planetary System Animation 2"
          className="w-96 object-cover"
        />
      </div>

      <div className="flex flex-col gap-4 text-justify w-3/4 items-center">
        <p className="text-lg">
          Space-Guesser is a simple game that aims to explore and expand your
          knowledge about our solar system. The game consists of rounds where
          the user will receive a planet and some quantitative and qualitative
          data (its mass, description, gravity...) and based on these
          information the user has to try to guess the distance of the planet
          and the size of the planet
        </p>
        <p className="text-lg">
          The game has 3 rounds where you accumulate points based on how close
          your guess is to the actual value. You get a score out of 2500 for
          both size and distance, which sums up to a total of 5000. At the end
          of the 3 rounds, you can see the final score in a personal and a
          public leaderboard.
        </p>
        <p className="text-sm w-1/2 mt-4 italic">
          Some of the measurements of the planets could have a small error. This
          is due to approximation issues from the retrieved APIs.
        </p>
      </div>

      <div className="flex lg:flex-row lg:items-start items-center flex-col w-3/4 justify-around mt-4">
        <div className="flex flex-col mt-8 lg:w-1/2 gap-8 text-justify">
          <p className="text-lg flex flex-col items-center">
            Check out the project repository on GitHub:
            <a
              href="https://gits-15.sys.kth.se/iprog-students/amicheli-danina-gauri-wanke-vt24-project"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#5E6DBA] flex items-center gap-2 hover:brightness-150"
            >
              <img
                src="https://cdn.worldvectorlogo.com/logos/github-icon-2.svg"
                alt="github logo"
                className="w-8 h-8"
              />
              Space Guesser Repository
            </a>
          </p>
          <p className="flex flex-col items-center">
            The APIs used in this project are the following:
            <a
              href="https://rapidapi.com/newbAPIOfficial/api/planets-info-by-newbapi/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue flex items-center gap-2 hover:brightness-150"
            >
              Planets Info by NewbAPI
            </a>
            <a
              href="https://rapidapi.com/apininjas/api/planets-by-api-ninjas/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue flex items-center gap-2 hover:brightness-150"
            >
              Planets by API-Ninjas
            </a>
          </p>
          <p className="opacity-50 brightness-200">
            This project was the result of the DH2642 course run by Professor
            Bogdan in collaboration with Professor Matviienko.
          </p>
          <p className="opacity-50 brightness-200">
            Special thanks to the coaching of Marcus Alström.
          </p>
        </div>
        <div className="w-fit">
          <h2 className="text-2xl mt-8">Meet the Team:</h2>
          <div className="grid grid-cols-2 gap-4 mt-4">
            <a
              href="https://www.linkedin.com/in/danina-jansson-4681211bb/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex flex-col items-center filter grayscale hover:filter-none hover:cursor-pointer"
            >
              <img
                src="/assets/images/developers/Danina.jpeg"
                alt="Danina"
                className="rounded-full w-24 h-24"
              />
              <h3 className="text-lg mt-2">Danina</h3>
            </a>
            <a
              href="https://www.linkedin.com/in/gauribhatnagar/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex flex-col items-center filter grayscale hover:filter-none hover:cursor-pointer"
            >
              <img
                src="/assets/images/developers/Gauri.jpeg"
                alt="Gauri"
                className="rounded-full w-24 h-24"
              />
              <h3 className="text-lg mt-2">Gauri</h3>
            </a>
            <a
              href="https://www.linkedin.com/in/andrea-micheli-00ay00/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex flex-col items-center filter grayscale hover:filter-none hover:cursor-pointer"
            >
              <img
                src="/assets/images/developers/Andrea.jpeg"
                alt="Andrea"
                className="rounded-full w-24 h-24"
              />
              <h3 className="text-lg mt-2">Andrea</h3>
            </a>
            <a
              href="https://www.linkedin.com/in/christina-wanke/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex flex-col items-center filter grayscale hover:filter-none hover:cursor-pointer"
            >
              <img
                src="/assets/images/developers/Christina.jpeg"
                alt="Chris"
                className="rounded-full w-24 h-24 "
              />
              <h3 className="text-lg mt-2">Christina</h3>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StaticInfo;
